import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import { deleteBundleById } from "@actions/bundles.action";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";

const EditBundle = ({ bundleId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.bundles.loading);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeleteBundle = () => async () => {
    try {
      await dispatch(deleteBundleById(bundleId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/bundles/${bundleId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove Bundle">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this bundle?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeleteBundle(bundleId)} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const AdminBundlesTable = () => {
  const { all: bundles, fetching } = useSelector(({ bundles }) => bundles);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        isFiltered: true,
        isSorting: true,
      },
      {
        width: 100,
        id: "colEdit",
        Cell: ({ row }) => <EditBundle bundleId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => bundles, [bundles]);

  return <Table columns={columns} data={data} hasGlobalFilter loading={fetching} />;
};

export default AdminBundlesTable;
